import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import * as Styled from './styles';
import * as fromRoutes from 'routes';
import { ReactComponent as HomeIcon } from 'assets/icons/home.svg';
import { ReactComponent as RocketIcon } from 'assets/icons/rocket.svg';
import { ReactComponent as UserIcon } from 'assets/icons/user.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

const SideBar = ({ currentUser }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Styled.Wrapper isVisible={isVisible}>
      <Styled.Toggle
        isVisible={isVisible}
        onClick={() => setIsVisible(!isVisible)}>
        <Styled.Span isVisible={isVisible} />
        <Styled.Span isVisible={isVisible} />
        <Styled.Span isVisible={isVisible} />
      </Styled.Toggle>
      <NavLink to='/'>
        <Styled.Logo src={require('assets/images/logo.jpg')} />
      </NavLink>
      <Styled.Link
        to='/'
        exact={true}
        activeClassName='active'
        onClick={() => setIsVisible(!isVisible)}>
        <HomeIcon width={18} id='home' />
        <span>Home</span>
      </Styled.Link>
      <Styled.Link
        to='/example'
        activeClassName='active'
        onMouseOver={() => fromRoutes.AsyncExample.preload()}
        onClick={() => setIsVisible(!isVisible)}>
        <RocketIcon width={18} id='example' />
        <span>Example</span>
      </Styled.Link>

      {currentUser ? (
        <Styled.Link
          to='/account'
          activeClassName='active'
          onMouseOver={() => fromRoutes.AsyncAccount.preload()}
          onClick={() => setIsVisible(!isVisible)}>
          <UserIcon width={18} id='account' />
          <span>Account</span>
        </Styled.Link>
      ) : (
        <>
          <Styled.Link
            to='/sign_in'
            activeClassName='active'
            onMouseOver={() => fromRoutes.AsyncSignIn.preload()}
            onClick={() => setIsVisible(!isVisible)}>
            <UserIcon width={18} id='signIn' />
            <span>Log in</span>
          </Styled.Link>
          <Styled.Link
            to='/sign_up'
            activeClassName='active'
            onMouseOver={() => fromRoutes.AsyncSignUp.preload()}
            onClick={() => setIsVisible(!isVisible)}>
            <PlusIcon width={18} id='signup' />
            <span>Sign Up</span>
          </Styled.Link>
        </>
      )}
    </Styled.Wrapper>
  );
};

const mapStateToProps = (state, props) => {
  return {
    currentUser: state.auth.entity
  };
};

export default connect(mapStateToProps, {})(SideBar);
